export type StardustHandoffTokens = {
  accessToken?: string | null;
  refreshToken?: string | null;
};

/**
 * Builds a same-window Stardust hand-off URL: `provider=vpc` plus the patient's tokens so
 * Stardust continues them as themselves instead of starting a cold signup.
 *
 * Returns `null` when `rawUrl` is not a valid absolute URL — callers must not throw from a
 * click handler over a misconfigured setting.
 */
export const buildStardustHandoffUrl = (
  rawUrl: string,
  tokens: StardustHandoffTokens = {}
): string | null => {
  let target: URL;

  try {
    target = new URL(rawUrl);
  } catch {
    return null;
  }

  target.searchParams.set('provider', 'vpc');
  if (tokens.accessToken) target.searchParams.set('accessToken', tokens.accessToken);
  if (tokens.refreshToken) target.searchParams.set('refreshToken', tokens.refreshToken);

  return target.toString();
};

/**
 * Same-window navigation to Stardust. Do not switch to `window.open` — even with `_self` it
 * can be popup-blocked, and these URLs carry auth tokens in the query string.
 */
export const assignStardustHandoff = (
  rawUrl: string,
  tokens: StardustHandoffTokens = {}
): boolean => {
  const href = buildStardustHandoffUrl(rawUrl, tokens);
  if (!href) return false;

  window.location.assign(href);
  return true;
};
